import { css } from 'lit';
import { FlensSlide } from './slider-slide';

export class FlensProductSliderImage extends FlensSlide {
	static properties = {
		productId: { type: Number, attribute: 'product-id' },
		categoryId: { type: Number, attribute: 'category-id' },
	};

	static styles = css`
    :host {
      --scale: 1;

      inline-size: 100%;
      max-block-size: 100%;
      scroll-snap-align: var(--scroll-snap-align, center);
    }

    :host(:not([active])) {
      --scale: 0.7;

      opacity: 0.7;
    }

    ::slotted(img) {
      block-size: 100%;
      inline-size: 100%;
      object-fit: contain !important;
      object-position: center;
      position: relative;
      scale: var(--scale);
      z-index: 2;
    }

    @media screen and (width >= 992px) {
      ::slotted(img) {
        object-position: right bottom;
      }
    }

    @media (prefers-reduced-motion: no-preference) {
      :host,
      ::slotted(img) {
        transition: 0.3s all ease-out;
      }
    }
  `;

	constructor() {
		super();
		this.productId = -1;
		this.categoryId = -1;
	}
}

customElements.define('flens-product-slider-image', FlensProductSliderImage);
